import * as runtypes from 'runtypes';
import * as institution from 'src/models/institution';

export const VisibleInstitution = institution.types.Institution.withBrand('VisibleInstitution').withConstraint(
  (data) => institution.toVisible(data) !== null
);

export type VisibleInstitution = runtypes.Static<typeof VisibleInstitution>;
